import * as Popover from '@radix-ui/react-popover'
import { LinkEditorPanel } from '../../../panels'
import { Icon } from '../../../ui/Icon'
import { Toolbar } from '../../../ui/Toolbar'

export type EditLinkPopoverProps = {
	onSetLink: (link: string, openInNewTab?: boolean) => void
}

export const EditLinkPopover = ({ onSetLink }: EditLinkPopoverProps) => {
	return (
		<Popover.Root>
			<Popover.Trigger asChild>
				<Toolbar.Button tooltip="Set Link">
					<Icon name="Link2" />
				</Toolbar.Button>
			</Popover.Trigger>
			<Popover.Content
				sideOffset={12}
				side="top"
				align="start"
				alignOffset={-4}
				className="custom-popover"
			>
				<LinkEditorPanel onSetLink={onSetLink} />
			</Popover.Content>
		</Popover.Root>
	)
}
